import { ImageType } from 'utils/types';

import { BiomarkersCardsSectionProps } from './BiomarkersCardsSection';

export const parseBiomarkersCardsSection = (
  section: Queries.ContentfulSection001,
): BiomarkersCardsSectionProps | null => {
  const title = section?.metadata?.title || '';
  const eyebrow = section?.eyebrow || '';
  const disclaimer =
    section?.metadata?.description?.childMarkdownRemark?.html || '';

  const cards = section?.subsections as Queries.ContentfulSection001[];

  const biomarkersCards = cards?.map((card) => {
    const title = card?.metadata?.title || '';
    const description = card?.metadata?.description?.description || '';
    const markers =
      (card?.subsections?.[0] as Queries.ContentfulList001)?.listItems?.map(
        (marker) => marker?.text || '',
      ) ?? [];
    const iconImage = card?.images?.[0]?.desktopImage as ImageType;

    return {
      title,
      description,
      markers,
      iconImage,
    };
  });

  return {
    title,
    eyebrow,
    disclaimer,
    cards: biomarkersCards ?? [],
  };
};
